module.exports = __webpack_public_path__ + "media/errors/404-wisenheimer-sleeping-be936b8e.png";